import { EnhancedHeader } from '@/components/EnhancedHeader';
import { EsportsPredictions } from '@/components/EsportsPredictions';

export default function Esports() {
  return (
    <div className="min-h-screen bg-gradient-dark">
      <EnhancedHeader />
      <main className="container mx-auto px-4 py-8">
        <h1 className="sr-only">Esports Predictions</h1>
        <EsportsPredictions />
      </main>
    </div>
  );
}
